import NewItemModal from './new-item-modal';

export default NewItemModal;